import * as React from 'react';
import cx from 'classnames';
import { Tag } from '../types/reference';

import Android from './Icons/Android';
import IOS from './Icons/IOS';

interface Props {
  tags: Tag[];
}

function Tags({ tags }: Props) {
  return (
    <div className="flex">
      {tags.map(props => {
        if (props.tag === 'platform') {
          return <Platform {...props} />;
        }

        return <Generic {...props} />;
      })}
    </div>
  );
}

function Generic({ tag, text }: Tag) {
  return (
    <div className="flex item-center bg-gray-100 text-gray-800 text-base rounded border px-3 py-1">
      {`${tag}: ${text}`}
    </div>
  );
}

function Platform(props: Tag) {
  const { text } = props;
  const [platform, ...children] = text.split(' ');
  const type = platform.trim();

  return (
    <div
      style={{ top: 20 }}
      className={cx('relative flex item-center text-base rounded border px-3 py-1', {
        'text-android border-android': type === 'android',
        'text-ios dark:text-white border-gray-900 dark:border-gray-100': type === 'ios',
      })}
    >
      {type === 'android' && (
        <>
          <Android className="mr-1" />
          <span>{children.length === 1 ? children.join(' ') : 'Android Only'}</span>
        </>
      )}
      {type === 'ios' && (
        <>
          <IOS branding={false} className="mr-1 dark:text-white" size={22} />
          <span>{children.length ? children.join(' ') : 'iOS Only'}</span>
        </>
      )}
    </div>
  );
}

export default Tags;
